export const mapJobInterestFormDataToAPIParams = ({
  idHash,
  isInterested,
  notInterestedReasonId,
  notInterestedFeedback,
  availabilityConfirmed,
  canOverlapWithTimezone,
  salaryConfirmed,
  salaryChangeReason,
  newDesiredSalaryMonthly,
  newDesiredSalaryHourly,
  keepSalaryChangeFutureJobs,
  perfectFitQuestionAnswer,
  customQuestionAnswer,
  customQuestionAnswerJson,
  greetings,
  customVetsmithMessage,
  dataIntegrityConfirmed,
  deviceUsed,
  developerTimezoneId,
}) => {
  return {
    idHash,
    isInterested,
    notInterestedReasonId,
    notInterestedFeedback,
    availabilityConfirmed,
    canOverlapWithTimezone,
    salaryConfirmed,
    salaryChangeReason,
    newDesiredSalaryMonthly,
    newDesiredSalaryHourly,
    keepSalaryChangeFutureJobs,
    perfectFitQuestionAnswer,
    customQuestionAnswer,
    customQuestionAnswerJson,
    greetings,
    customVetsmithMessage,
    dataIntegrityConfirmed,
    deviceUsed,
    developerTimezoneId,
    submissionSource: "JRF_JOB_DASHBOARD"
  };
};
